import React from 'react';
import { Flex, Badge } from '@spothero/ui';
export const MOST_POPULAR_TAG = 'Most Popular';
const AirportSpotTag = ({ tag, spotsLeft, title }) => {
    const message = spotsLeft > 1 ? 'Spots Left' : 'Spot Left';
    const styles = {
        py: '1px',
        px: '2',
        textAlign: 'center',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: 'base',
        fontSize: 'xs',
        fontWeight: 'semibold',
    };
    // For now this is implemented in UI as we don't want to show the tag but want sorting to happen for Most Popular spots.
    // All the sorting logic will be moved to BE and this condition can be cleaned up along with the airport sorting logic.
    const showTag = tag && tag !== MOST_POPULAR_TAG;
    if (!showTag && !spotsLeft) {
        return null;
    }
    return (<Flex mx={3} mt={3} className="AirportSpotTag" data-testid={`AirportTag-${encodeURIComponent(title)}`}>
            {showTag && (<Badge {...styles} mr="2">
                    {tag}
                </Badge>)}
            {spotsLeft && (<Badge {...styles}>
                    {spotsLeft} {message}
                </Badge>)}
        </Flex>);
};
export default AirportSpotTag;
